package com.artvending.warden

enum class Page {
	HOME,
	SCANNER,
	HISTORY
}